
import React, { useEffect, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import Axios from "axios";
import AxiosInstance from "../../AxiosInstance";
import { useImmerReducer } from 'use-immer';
import { Grid, Typography, CircularProgress, Box } from "@mui/material";
import { useTranslation } from 'react-i18next';

import StateContext from "../../Contexts/StateContext";
import defaultProfilePicture from "../../Assets/defaultProfilePicture.jpg";
import ProfileUpdate from "./ProfileUpdate";
import TwoFASetup from "./TwoFASetup";

import config, { environment } from '../../config';

function Profile() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const GlobalState = useContext(StateContext);

    const initialState = {
        userProfile: {
            companyName: '',
            phoneNumber: '',
            profilePic: '',
            bio: '',
            sellerListings: [],
            sellerId: '',
            is2FAEnabled: false
        },
        dataIsLoading: true,
        refetchTrigger: 0,
    };

    function reducer(draft, action) {
        switch(action.type) {
            case 'catchUserProfileInfo':
                Object.assign(draft.userProfile, {
                    companyName: action.profile.company_name,
                    phoneNumber: action.profile.phone_number,
                    profilePic: action.profile.profile_picture,
                    bio: action.profile.bio,
                    sellerListings: action.profile.seller_listings,
                    sellerId: action.profile.seller,
                    is2FAEnabled: action.profile.is_2fa_enabled
                });
                break;
            case 'loadingDone':
                draft.dataIsLoading = false;
                break;
            case 'triggerRefetch':
                draft.refetchTrigger++;
                break;
            default:
                break;
        }
    }

    const [state, dispatch] = useImmerReducer(reducer, initialState);

    // Fetch profile after login or when refetch is triggered
    useEffect(() => {
        if (!GlobalState.jwtAccessToken || !GlobalState.userId) return;

        const fetchProfile = async () => {
            try {
                const res = await AxiosInstance.get(
                    config[environment].getProfileEndpoint(GlobalState.userId)
                );

                dispatch({ type: 'catchUserProfileInfo', profile: res.data });
            } catch (e) {
            } finally {
                dispatch({ type: 'loadingDone' });
            }
        };

        fetchProfile();
    }, [GlobalState.jwtAccessToken, GlobalState.userId, environment, state.refetchTrigger]);

    // Function to trigger profile refetch
    function handleProfileUpdate() {
        dispatch({ type: 'triggerRefetch' });
    }

    if (state.dataIsLoading) return (
        <Grid container justifyContent="center" alignItems="center" style={{ height: "100vh" }}>
            <CircularProgress />
        </Grid>
    );

    return (
        <Box sx={{ p: { xs: 2, md: 4 }, mt: '50px' }}>
            <Typography variant={GlobalState.userUsername.length > 15 ? "h6" : "h5"} align="center" sx={{ mt: 2 }}>
                {t('Administration.Welcome')} <span style={{ color: 'green' }}>{GlobalState.userUsername}</span>
            </Typography>

            <Grid container justifyContent="center" sx={{ mt: 3 }}>
                <Box
                    component="img"
                    src={state.userProfile.profilePic || defaultProfilePicture}
                    alt="Profile"
                    sx={{
                        width: { xs: 120, md: 160 },
                        height: { xs: 120, md: 160 },
                        borderRadius: '50%',
                        objectFit: 'cover',
                        border: '3px solid green'
                    }}
                />
            </Grid>

            <Grid container justifyContent="center" sx={{ mt: 2 }}>
                <TwoFASetup
                    initialEnabled={state.userProfile.is2FAEnabled}
                    jwtAccessToken={GlobalState.jwtAccessToken}
                />
            </Grid>

            <ProfileUpdate
                userProfile={state.userProfile}
                onProfileUpdated={handleProfileUpdate}
            />
        </Box>
    );
}

export default Profile;